import * as React from 'react';
import { BaseComponent } from './BaseComponent';
import { LoadingCounter, LoadingCounterProps } from './LoadingCounter';

export interface LoadingAnimationProps {
    classOverride?: string;
    text?: string;
    mainComponent?: JSX.Element | null;
    counterProps?: LoadingCounterProps;
}

export class LoadingAnimation extends BaseComponent<LoadingAnimationProps, {}> {
    public render(): JSX.Element {
        if (this.props.text) {
            return (
                <div className="loading-with-text">
                    {this.props.mainComponent ? this.props.mainComponent : this.circleAnimation()}
                    <div className="loading-text">{this.props.text}</div>
                </div>
            );
        }
        if (this.props.mainComponent != null) {
            return this.props.mainComponent;
        }
        return this.circleAnimation();
    }

    protected circleAnimation(): JSX.Element {
        const baseClass: string = this.props.classOverride ? this.props.classOverride : 'core-loading';
        return (
            <div className={baseClass + ' core-loading-show'}>
                    <div className="core-loading-circle-state-1"/>
                    <div className="core-loading-circle-state-2"/>
                    <div className="core-loading-circle-state-3"/>
                    <div className="core-loading-circle-state-4"/>
                    <div className="core-loading-circle-state-5"/>
                    <div className="core-loading-circle-state-6"/>
                    <div className="core-loading-circle-state-7"/>
                    <div className="core-loading-circle-state-8"/>
                    {this.props.counterProps != null ? <LoadingCounter {...this.props.counterProps}/> : null}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoadingAnimation.tsx